<mat-toolbar>
  <div class="flex space-between width--100-percent align-items--center">
    <div class="width--max-content link" [routerLink]="['/template-list']">
     Fusion Web
    </div>
    <div>
      @if (!userState.isSignedIn()) {
        <button mat-icon-button matTooltip="Sign In" (click)="signIn()">
          <mat-icon>login</mat-icon>
        </button>
      }
      @if (userState.isSignedIn()) {
        <button mat-button [matMenuTriggerFor]="menu">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <a mat-menu-item [routerLink]="['/template-list']">Template List</a>
          <a mat-menu-item href="https://bookstack.agvancesky.com/books/fusion" target="_blank">Help Center ↗️</a>
          <a mat-menu-item [routerLink]="['/analytics/template-usage']">Template Statistics</a>
          <a mat-menu-item [routerLink]="['/analytics/template-invocations']">Template Invocation Data</a>
          <a mat-menu-item [routerLink]="['/cli-access']">CLI Access</a>
          <button mat-menu-item (click)="signOut()">Sign Out</button>
        </mat-menu>
      }
    </div>
  </div>

</mat-toolbar>
<div style="margin:1em">
  <router-outlet></router-outlet>
</div>
